"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));
var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _TextField = _interopRequireDefault(require("../../TextField"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _ref2 = /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
  position: "start"
}, /*#__PURE__*/_react["default"].createElement(_Search["default"], null));
var control = function control(_ref) {
  var _InputProps$classes, _InputProps$classes2, _InputProps$classes3, _InputProps$classes4;
  var selectProps = _ref.selectProps,
    innerProps = _ref.innerProps,
    innerRef = _ref.innerRef,
    children = _ref.children,
    isDisabled = _ref.isDisabled;
  var InputProps = selectProps.InputProps;
  var inputProps = InputProps.inputProps;
  var showAdornmentStyle = selectProps.textFieldAdornment && selectProps.isSearchable;
  var focusClasses = selectProps.isMulti ? selectProps.classes.focusedMulti : selectProps.classes.focused;
  return /*#__PURE__*/_react["default"].createElement(_TextField["default"], (0, _extends2["default"])({
    disabled: isDisabled,
    fullWidth: true,
    ref: innerRef,
    InputProps: _objectSpread({}, InputProps, {
      classes: _objectSpread({}, InputProps.classes, {
        disabled: (0, _classnames["default"])(selectProps.classes.disabled, InputProps === null || InputProps === void 0 ? void 0 : (_InputProps$classes = InputProps.classes) === null || _InputProps$classes === void 0 ? void 0 : _InputProps$classes.disabled),
        error: (0, _classnames["default"])(selectProps.classes.error, InputProps === null || InputProps === void 0 ? void 0 : (_InputProps$classes2 = InputProps.classes) === null || _InputProps$classes2 === void 0 ? void 0 : _InputProps$classes2.error),
        focused: (0, _classnames["default"])(focusClasses, InputProps === null || InputProps === void 0 ? void 0 : (_InputProps$classes3 = InputProps.classes) === null || _InputProps$classes3 === void 0 ? void 0 : _InputProps$classes3.focused),
        root: showAdornmentStyle ? selectProps.classes.adornedStart : undefined,
        // using adornedStart classes property throws warning since it's part of InputBase and not Input
        underline: (0, _classnames["default"])(selectProps.classes.inputUnderlined, InputProps === null || InputProps === void 0 ? void 0 : (_InputProps$classes4 = InputProps.classes) === null || _InputProps$classes4 === void 0 ? void 0 : _InputProps$classes4.underline)
      }),
      disabled: isDisabled,
      inputComponent: 'div',
      inputProps: _objectSpread({}, inputProps, {}, innerProps, {
        children: children,
        className: (0, _classnames["default"])(selectProps.classes.input, inputProps === null || inputProps === void 0 ? void 0 : inputProps.className, (0, _defineProperty2["default"])({}, selectProps.classes.inputAdornedStart, showAdornmentStyle)),
        'data-metrics': selectProps.dataMetrics.control
      }),
      startAdornment: showAdornmentStyle ? _ref2 : undefined
    })
  }, selectProps.textFieldProps));
};
var _default = control;
exports["default"] = _default;